(() => {
  const SWATCH_SELECTOR = '[data-home-product-swatch]';

  const updateCard = (swatch) => {
    const card = swatch.closest('.home-product-card');
    if (!card) return;

    card.querySelectorAll(SWATCH_SELECTOR).forEach((item) => {
      const active = item === swatch;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const image = card.querySelector('.home-product-card__image--primary');
    card.classList.add('has-selected-swatch');
    if (image && swatch.dataset.imageSrc) {
      image.src = swatch.dataset.imageSrc;
      if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
      if (swatch.dataset.imageAlt) image.alt = swatch.dataset.imageAlt;
    }

    if (swatch.dataset.variantUrl) {
      card.querySelectorAll('[data-home-product-link]').forEach((link) => {
        link.href = swatch.dataset.variantUrl;
      });
    }

    const price = card.querySelector('[data-home-product-price]');
    if (price && swatch.dataset.price) {
      const regular = document.createElement('span');
      regular.textContent = swatch.dataset.price;
      price.replaceChildren(regular);

      if (swatch.dataset.comparePrice) {
        const compare = document.createElement('s');
        compare.textContent = swatch.dataset.comparePrice;
        price.append(compare);
      }
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;
    updateCard(swatch);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(`${SWATCH_SELECTOR}.is-active`).forEach(updateCard);
    initCarousels(event.target);
  });

  function initCarousels(scope = document) {
    scope.querySelectorAll('[data-home-carousel]:not([data-carousel-ready])').forEach(root => {
      const track = root.querySelector('.home-product-carousel__track');
      if (!track) return;
      root.dataset.carouselReady = 'true';
      const previous = root.querySelector('[data-home-carousel-prev]');
      const next = root.querySelector('[data-home-carousel-next]');
      const progress = root.querySelector('[data-home-carousel-progress]');
      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const current = Math.max(0, Math.min(max, track.scrollLeft));
        previous.disabled = current < 2;
        next.disabled = current >= max - 2;
        const fraction = Math.min(1, track.clientWidth / track.scrollWidth);
        progress.style.width = `${fraction * 100}%`;
        progress.style.left = `${max ? current / max * (1 - fraction) * 100 : 0}%`;
      };
      const move = direction => track.scrollBy({left: direction * Math.max(240, track.clientWidth * 0.75), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if(event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      if('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  }
  initCarousels();
})();
